import getRecords from './getRecords';
/** Returns a record identified by ID. Queries only local data. Does not fetch data from remote server */
export default function getRecordById(entity, id) {
    const records = getRecords(entity);
    if (Array.isArray(records) && records.length > 0) {
        return records.find((r) => r.id === id);
    }
}
